const MIME_TYPES = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/mpeg']

export function isVoiceInputSupported() {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && typeof MediaRecorder !== 'undefined')
}

function pickMimeType() {
  return MIME_TYPES.find(type => MediaRecorder.isTypeSupported(type)) || ''
}

function extensionFor(mimeType) {
  if (mimeType.includes('webm')) return 'webm'
  if (mimeType.includes('mp4')) return 'mp4'
  return 'mp3'
}

export function createVoiceRecorder() {
  let recorder = null
  let stream = null
  let chunks = []

  function cleanup() {
    if (stream) {
      stream.getTracks().forEach(track => track.stop())
      stream = null
    }
    recorder = null
    chunks = []
  }

  async function start() {
    if (!isVoiceInputSupported()) {
      throw new Error('Voice input is not supported in this browser')
    }
    stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    const mimeType = pickMimeType()
    recorder = mimeType ? new MediaRecorder(stream, { mimeType }) : new MediaRecorder(stream)
    chunks = []
    recorder.ondataavailable = event => {
      if (event.data && event.data.size > 0) chunks.push(event.data)
    }
    recorder.start()
  }

  function stop() {
    return new Promise((resolve, reject) => {
      if (!recorder) {
        reject(new Error('Not recording'))
        return
      }
      const mimeType = recorder.mimeType || 'audio/webm'
      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: mimeType })
        const timestamp = new Date().toISOString().replace(/:/g, '-').replace(/\..+/, '')
        const file = new File([blob], `voice_${timestamp}.${extensionFor(mimeType)}`, { type: mimeType })
        cleanup()
        resolve(file)
      }
      try {
        recorder.stop()
      } catch (err) {
        cleanup()
        reject(err)
      }
    })
  }

  function cancel() {
    if (recorder) {
      recorder.onstop = cleanup
      try {
        recorder.stop()
      } catch {
        cleanup()
      }
    } else {
      cleanup()
    }
  }

  return { start, stop, cancel }
}
